const investExpertiseAssetsTableListedAssets = {
	name: {
		tag: 'investExpertiseAssetsTableListedAssets.name',
		fr: 'Nom',
		en: 'Name',
	},
	country: {
		tag: 'investExpertiseAssetsTableListedAssets.country',
		fr: 'Pays',
		en: 'Country',
	},
	businessSector: {
		tag: 'investExpertiseAssetsTableListedAssets.businessSector',
		fr: "Secteur d'activité",
		en: 'Business sector',
	},
	assetType: {
		tag: 'investExpertiseAssetsTableListedAssets.assetType',
		fr: "Type d'actif",
		en: 'Asset type',
	},
	weightInFund: {
		tag: 'investExpertiseAssetsTableListedAssets.weightInFund',
		fr: 'Poids dans le fonds',
		en: 'Weight in fund',
	},
	noDataAvailable: {
		tag: 'investExpertiseAssetsTableListedAssets.noDataAvailable',
		fr: 'Aucune donnée disponible',
		en: 'No data available',
	},
};

export default investExpertiseAssetsTableListedAssets;
